import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/services", label: "Services" },
  { to: "/membership", label: "Membership" },
  { to: "/leaders", label: "Leaders" },
  { to: "/events", label: "Events" },
  { to: "/about", label: "About" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[color:var(--bg)]/80 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display text-xl md:text-2xl ink tracking-tight"
        >
          Midcreatives<span className="ink-muted">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 border border-white/10 bg-white/[0.03] backdrop-blur-xl px-1.5 py-1.5 rounded-full">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
                  isActive
                    ? "bg-white text-[color:var(--bg)]"
                    : "ink-muted hover:text-white hover:bg-white/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/apply"
            data-testid="nav-apply-cta"
            className="hidden md:inline-flex btn-dark"
          >
            Get Membership <span className="arrow-slide">→</span>
          </Link>
          <button
            className="md:hidden ink p-2"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-white/10 bg-[color:var(--bg)]/95 backdrop-blur-xl"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} className="ink text-lg font-medium">
                {l.label}
              </NavLink>
            ))}
            <Link to="/apply" className="btn-dark justify-center mt-2" data-testid="mobile-apply-cta">
              Get Membership <span className="arrow-slide">→</span>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
